import React from 'react'
import moreBtn from '../../../Assets/Images/more-btn.svg'
import smile from '../../../Assets/Images/smile.svg'
import walk from '../../../Assets/Images/walk.svg'
import history from '../../../Assets/Images/history.svg'
import heart from '../../../Assets/Images/calendar-heart.svg'
import { TailSpin } from 'react-loader-spinner';

export default function Table({ data }) {

  // // console.log("data: ",data)

  const getStatusColor = (status) => {
    switch (status) {
      case "Employed": return {
        background: '#97E7E780',
        text: '#0C849E'
      };
      case "Retired": return {
        background: '#ACDCFF80',
        text: '#105CA1'
      };
      case "Student": return {
        background: '#C5C4FF80',
        text: '#4B33AB'
      };
      case "SAHP": return {
        background: '#F0C5FF80',
        text: '#8234BF'
      };
      case "Homemaker": return {
        background: '#FFC1E280',
        text: '#B51687'
      };
      case "Caregiver": return {
        background: '#FFBFCA80',
        text: '#A01854'
      };
      case "Volunteer": return {
        background: '#FFBDB480',
        text: '#B91111'
      };
      case "Unemployed": return {
        background: '#D9D9D980',
        text: '#666666'
      };
      default: return {
        background: '#000000',
        text: '#ffffff'
      };
    }
  }
  const getRatingColor = (rating) => {
    if (rating >= 1 && rating < 2) {
      return {
        background: '#F48956',
        text: '#000000'
      }
    }
    else if (rating >= 2 && rating < 3) {
      return {
        background: '#F8C9B4',
        text: '#000000'
      }
    }
    else if (rating >= 3 && rating < 4) {
      return {
        background: '#DDEBA9',
        text: '#000000'
      }
    }
    else if (rating >= 4 && rating < 5) {
      return {
        background: '#ACC549CC',
        text: '#ffffff'
      }
    }
    else if (rating >= 5) {
      return {
        background: '#7D8704',
        text: '#ffffff'
      }
    }
  }
  return (
    <div className='catalog-table'>
      <div className='table-head'>
        <div className="cell cell-congregant">Congregant</div>
        <div className="cell cell-status">Status</div>
        <div className="cell cell-occupation">Occupation</div>
        <div className="cell cell-industry">Industry</div>
        <div className="cell cell-actions">
          <div className='cell-actionsHeader'>
            Daily Work
            <div className='action-container'>
              <div className="action">SEN</div>
              <div className="action">PRC</div>
            </div>
          </div>
          <div className='cell-actionsHeader'>
            Church
            <div className='action-container'>
              <div className="action">HIST</div>
              <div className="action">INTR</div>
            </div>
          </div>
          <div className="more-btn"><img src={smile} width={24} height={24} alt="more-btn" /></div>
        </div>
      </div>
      <div className="table-body">
        {data.length > 0 ? data.map((row, index) => (
          <div className="table-row" key={index}>
            <div className="cell cell-congregant">
              <div className="name">{row.name}</div>
              <div className="info">{row.gender}, {row.age}</div>
            </div>
            <div className="cell cell-status">
              <div className="current-status" style={{ color: getStatusColor(row.status).text, backgroundColor: getStatusColor(row.status).background }}>{row.status}</div>
            </div>
            <div className="cell cell-occupation">
              <div className="name">{row?.occupation?.occupation}</div>
              <div className="info">{row?.occupation?.occupationalGroup}</div>
            </div>
            <div className="cell cell-industry">{row.industry?.industry}</div>
            <div className="cell cell-actions">
              <div className="rating" style={{ color: getRatingColor(row.sentiments)?.text, backgroundColor: getRatingColor(row.sentiments)?.background }}>{row?.sentiments}</div>
              <div className="rating" style={{ color: getRatingColor(row.practices)?.text, backgroundColor: getRatingColor(row.practices)?.background }}>{row?.practices}</div>
              <div className="rating" style={{ color: getRatingColor(row.history)?.text, backgroundColor: getRatingColor(row.history)?.background }}>{row?.history}</div>
              <div className="rating" style={{ color: getRatingColor(row.interest)?.text, backgroundColor: getRatingColor(row.interest)?.background }}>{row?.interest}</div>
              <img src={moreBtn} width={24} height={24} alt="more-btn" />
            </div>
          </div>
        )) :
          <div className='loader'>
            <TailSpin
              height="60"
              width="60"
              radius="9"
              color="green"
              ariaLabel="loading"
            />
          </div>
        }
      </div>
    </div>
  )
}
